import { createAction } from 'redux-actions';

const ACTION_PREFIX = 'remote';

export const BEGIN_SAVE            = `${ACTION_PREFIX}/BeginSave`;
export const SAVE_FAILED           = `${ACTION_PREFIX}/SaveFailed`;
export const DISCARD_LOCAL_CHANGES = `${ACTION_PREFIX}/DiscardLocalChanges`;
export const ENTITY_DELETED        = `${ACTION_PREFIX}/EntityDeleted`;
export const UPDATE_FROM_SERVER    = `${ACTION_PREFIX}/UpdateFromServer`;
export const SAVED_TO_SERVER       = `${ACTION_PREFIX}/SavedToServer`;

export const beginSave = () => ({
  type: BEGIN_SAVE,
});

export const saveFailed = () => ({
  type: SAVE_FAILED,
});

export const discardLocalChanges = () => ({
  type: DISCARD_LOCAL_CHANGES,
});

export const savedToServer = (payload = null, type = null, id = null) =>
  ({ type: SAVED_TO_SERVER, payload: { payload, type, id } });
export const updateFromServer = (payload, type = null, id = null) =>
  ({ type: UPDATE_FROM_SERVER, payload: { payload, type, id } });

export const entityDeleted = (type, id) => {
  const { kind, storePrefix } = type;

  return {
    type: ENTITY_DELETED,
    payload: { kind, storePrefix, id },
  };
};

const optimisticMeta = (payload, meta) => ({
  ...meta,
  optimistic: true,
});

const makeOptimistic = (innerMeta) => (payload) =>
  Object.assign(optimisticMeta(payload), innerMeta(payload));

export const createOptimisticAction = (type, actionCreator, metaCreator) => {
  const optimisticMetaCreator = metaCreator ? makeOptimistic(metaCreator) : optimisticMeta;
  return createAction(type, actionCreator, optimisticMetaCreator);
};
